<eventq-action-loader
  class="escalation-waiting"
  fill="panel"
  [message]="message"
  [pulsing]="false"
  emblemSrc="/assets/events/ecam-emblem.svg"
/>
